import React, { useEffect } from "react";
import NoteAttachmentDownloadButton from "./NoteAttachmentDownloadButton";
import NoteAttachmentIndicator from "./NoteAttachmentIndicator";
import NoteSubjectTag from "./NoteSubjectTag";
import {
  deriveNoteTitle,
  getNoteAttachmentCount,
  noteHasAttachments,
} from "../../utils/myNotes";

function ViewNoteModal({ note, onClose, onEdit }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  if (!note) {
    return null;
  }

  const displayTitle = deriveNoteTitle(note.title, note.content, {
    attachments: note.attachments,
  });
  const noteTags = note.tags || [];
  const attachmentCount = getNoteAttachmentCount(note);

  return (
    <div className="my-notes-modal-overlay" role="presentation">
      <div
        className="my-notes-modal my-notes-view-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="view-note-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="my-notes-modal-header my-notes-modal-header-with-title">
          <h1 id="view-note-title" className="my-notes-modal-note-title">
            {displayTitle}
          </h1>
          <div className="my-notes-modal-header-actions">
            {noteHasAttachments(note) ? (
              <NoteAttachmentIndicator count={attachmentCount} />
            ) : null}
            <button
              type="button"
              className="my-notes-modal-close"
              aria-label="Close note"
              onClick={onClose}
            >
              ×
            </button>
          </div>
        </div>

        <div className="my-notes-modal-body">
          <div className="my-notes-view-content-wrap">
            <button
              type="button"
              className="my-notes-view-edit-btn"
              aria-label="Edit note"
              onClick={() => onEdit?.(note)}
            >
              <img src="/assets/images/pencil-new.svg" alt="" aria-hidden="true" />
            </button>
            <div
              className="my-notes-view-content"
              dangerouslySetInnerHTML={{ __html: note.content }}
            />
          </div>

          {noteHasAttachments(note) ? (
            <div className="my-notes-view-attachments">
              <span className="my-notes-view-tags-label">
                <NoteAttachmentIndicator count={attachmentCount} />
                Attachments
              </span>
              <ul className="my-notes-view-attachment-list">
                {(note.attachments || []).map((attachment) => (
                  <li key={attachment.id} className="my-notes-view-attachment-item">
                    <span className="my-notes-attachment-name" title={attachment.fileName}>
                      {attachment.fileName}
                    </span>
                    <NoteAttachmentDownloadButton attachment={attachment} />
                  </li>
                ))}
              </ul>
            </div>
          ) : null}

          {noteTags.length > 0 ? (
            <div className="my-notes-view-tags">
              <span className="my-notes-view-tags-label">Tags:</span>
              <div className="my-notes-tag-list">
                {noteTags.map((tag) => (
                  <NoteSubjectTag key={tag} tag={tag} />
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default ViewNoteModal;
